import { OrderEmergensiStatus } from "@/types/order_emergensi";

export const STATUS_ORDER_EMERGENSI: Record<
  OrderEmergensiStatus,
  { label: string; color: string }
> = {
  dikirim: { label: "Terkirim ke Farmasi", color: "orange darken-2" },
  didispensing: { label: "Sudah Dispensing", color: "blue darken-1" },
  refill_diminta: { label: "Menunggu Isi Ulang", color: "indigo" },
  selesai: { label: "Selesai", color: "green darken-1" },
  batal: { label: "Dibatalkan", color: "grey" }
};

export const INDIKASI_DEFAULT = "Code Blue – Emergency";

export const ALASAN_READ_ONLY =
  "Rekam medis terkunci (lebih dari 48 jam setelah pasien pulang). Ajukan akses revisi bila perlu.";

export function buatUuid(): string {
  const c: Crypto | undefined = (window as any).crypto;
  if (c && typeof (c as any).randomUUID === "function") {
    return (c as any).randomUUID();
  }
  const bytes = new Uint8Array(16);
  if (c && c.getRandomValues) {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < 16; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function formatJumlah(nilai: number | null | undefined): string {
  if (nilai === null || nilai === undefined || (nilai as any) === "") return "";
  return String(Number(nilai));
}
